import { render } from "./tiger-machine.vue?vue&type=template&id=02556ff9&scoped=true&ts=true"
import script from "./tiger-machine.vue?vue&type=script&lang=ts"
export * from "./tiger-machine.vue?vue&type=script&lang=ts"

import "./tiger-machine.vue?vue&type=style&index=0&id=02556ff9&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02556ff9"]])

export default __exports__